import { randomString } from './random'
import hexToRgba from './hexToRgba'
import { runTimer } from './timer'
import debounce from './debounce'
import copyToClip from './copyToClip'
import { inModule, idleInModule, idleInModuleList, } from './inModule'
import { jsonStrToValue } from './json'
import getUrlQuery from './getUrlQuery'
import fixTime from './fixTime'
import downloadImage from './downloadImage'
import lang from './lang'
import setTimeRange from './setTimeRange'
import reserveUrlQuery from './reserveUrlQuery'
import replaceParamVal from './replaceParamVal'
import downloadExcel from './downloadExcel.js'
import cookies from './cookies.js'
import { getDecimalPlaces, c2cDecimalPlaces } from './getDecimalPlaces.js'
import { setLocalStorageWithExpiration, getLocalStorageWithExpiration } from './localStorage.js'
import { floorInt, roundup, ceilingInt } from './mathInt.js'
import assignObj from './assignObj.js'
import countDecimalPlaces from './countDecimalPlaces.js'
import formatNumber from './formatNumber.js'
import formatTime from './formatTime.js'
import isJson from './isJson.js'
import praseWsBlob from './praseWsBlob.js'
import useServerCountdown from './useServerCountdown.js'
import { getCurrentLocale, localizeUrl } from '@/utils/localeRoute.js'

import {
  checkType,
  isArray,
  isString,
  isNumber,
  isObject,
  isBoolean,
  isFunc,
  isRe,
  isJsonString,
  isEmpty,
  hasEmpty,
  isNaN,
  isZero,
  isNumeric,
  isIP,
} from './verifyType'

import { gt, gte, lt, lte } from './compare'

const fieldSet = (obj, key, value = null) => {
  if (isEmpty(obj[key])) {
    return
  }
  obj[key] = value
}

const addZero = (n) => {
  const s = String(n)
  if (s.length != 2) {
    return `0${s}`
  } else {
    return s
  }
}

const hideAccount = (str) => {
  return `${str.slice(0, 3)}****${str.slice(str.length - 4, str.length)}`
}

/**
 * 全局路由跳转方法，会自动补当前语言前缀。
 * @param {string|Object} params - 跳转目标。字符串形式如 '/trade?symbol=BTC_USDT'；对象形式必须包含 path，可选 query，如 { path: '/trade', query: { symbol: 'BTC_USDT' } }。
 * @param {Object} [options={}] - 跳转配置。
 * @param {boolean} [options.requireLogin=false] - 是否需要登录；未登录时跳转登录页。
 * @param {string} [options.redirect] - requireLogin 为 true 且未登录时，登录成功后要回跳的路径。
 * @param {boolean} [options.addUrlQuery=true] - params 为对象时是否继承当前页面query；false 时只使用 params.query。字符串形式跳转不受该参数影响。
 */
const toRouter = (params, options = {}) => {
  const { requireLogin = false, redirect, addUrlQuery = true } = options

  const currentLocale = getCurrentLocale({
    path: $route?.path || window.location.pathname,
  })

  if (requireLogin && !useUserStore().token) {
    return router.push({
      path: localizeUrl('/login', currentLocale),
      query: { redirect }
    })
  }

  if (isString(params)) {
    return router.push(localizeUrl(params, currentLocale))
  }

  if (!isObject(params) || !params.path) {
    throw new Error('toRouter 参数错误: 缺少 path')
  }

  const query = addUrlQuery
    ? { ...$route.query, ...(params.query || {}) }
    : { ...(params.query || {}) }

  router.push({
    path: localizeUrl(params.path, currentLocale),
    query
  })
}

const scrollbottom = (dom) => {
  const scrollTop = dom.scrollTop
  const clientHeight = dom.clientHeight
  const scrollHeight = dom.scrollHeight
  if (scrollTop + clientHeight >= scrollHeight - 10) {
    return true
  } else {
    return false
  }
}

const delNullKey = data => {
  return Object.keys(data).reduce((o, k) => {
    const e = {}
    const item = data[k]

    if (!isEmpty(item)) {
      e[k] = item
    }
    if (isObject(item)) {
      e[k] = delNullKey(item)
    }
    return { ...o, ...e }
  }, {})
}

const tryCatch = async (cb) => {
  try {
    return [null, await cb()]
  } catch (err) {
    return [err, null]
  }
}

const getLogoClass = (rankIndex, assetIndex, logoClassList = []) => {
  if (!logoClassList || !logoClassList.length) {
    return ''
  }
  return logoClassList[(Number(rankIndex) + Number(assetIndex)) % logoClassList.length]
}

export {
  checkType,
  isArray,
  isString,
  isNumber,
  isObject,
  isBoolean,
  isFunc,
  isRe,
  isJsonString,
  isEmpty,
  isNaN,
  hasEmpty,
  isIP,
  randomString,
  hexToRgba,
  runTimer,
  debounce,
  copyToClip,
  fieldSet,
  inModule,
  idleInModule,
  idleInModuleList,
  toRouter,
  scrollbottom,
  jsonStrToValue,
  delNullKey,
  fixTime,
  getUrlQuery,
  tryCatch,
  downloadImage,
  lang,
  setTimeRange,
  reserveUrlQuery,
  replaceParamVal,
  downloadExcel,
  addZero,
  isZero,
  isNumeric,
  gt,
  gte,
  lt,
  lte,
  getDecimalPlaces,
  cookies,
  c2cDecimalPlaces,
  hideAccount,
  setLocalStorageWithExpiration,
  getLocalStorageWithExpiration,
  floorInt,
  roundup,
  ceilingInt,
  assignObj,
  countDecimalPlaces,
  formatNumber,
  formatTime,
  isJson,
  praseWsBlob,
  useServerCountdown,
  getLogoClass
}
